import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Stagger, Item } from "@/components/shared/Reveal";
import { Icon } from "@/components/shared/Icon";

export const IndustriesGrid = () => (
  <section data-testid="industries-section" className="section relative bg-navy-900/50">
    <div className="wrap">
      <SectionHeading
        eyebrow="Industries"
        title="Built for organizations that move people, goods and vehicles."
        text="From individual fleet operators to large enterprise transportation operations."
      />
      <Stagger className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-line bg-line sm:grid-cols-2 lg:grid-cols-4" stagger={0.06}>
        {INDUSTRIES.map((ind) => (
          <Item key={ind.slug}>
            <Link to={`/industries#${ind.slug}`} data-testid={`industry-card-${ind.slug}`} className="group flex h-full min-h-[220px] flex-col bg-navy p-7 transition-colors duration-300 hover:bg-navy-800">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg border border-line text-cyan-400 transition-colors group-hover:border-cyan-400/50">
                <Icon name={ind.icon} className="h-5 w-5" />
              </span>
              <h3 className="mt-8 text-lg font-semibold">{ind.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{ind.text}</p>
              <span className="mt-auto flex items-center gap-1 pt-6 text-xs font-semibold text-slate-500 transition-colors group-hover:text-cyan-400">
                Learn more <ArrowRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-1" />
              </span>
            </Link>
          </Item>
        ))}
        <Item>
          <Link to="/contact" data-testid="industry-card-cta" className="group flex h-full min-h-[220px] flex-col justify-between bg-cyan-400 p-7 text-navy transition-colors duration-300 hover:bg-cyan-500">
            <ArrowUpRight className="h-6 w-6" />
            <div>
              <h3 className="text-lg font-semibold text-navy">Don't see your operation?</h3>
              <p className="mt-2 text-sm text-navy/80">Tell us what you run. We'll design around it.</p>
            </div>
          </Link>
        </Item>
      </Stagger>
    </div>
  </section>
);
